// Patch Flickity để cho phép pinch zoom
(function() {
  function patchFlickity() {
    if (!window.Flickity) {
      setTimeout(patchFlickity, 200);
      return;
    }

    // Override _touchActionValue từ 'pan-y' thành 'pan-y pinch-zoom'
    var proto = Flickity.prototype;
    proto._touchActionValue = 'pan-y pinch-zoom';

    // Patch _bindHandles để set đúng touch-action
    var orig_bindHandles = proto._bindHandles;
    proto._bindHandles = function(isAdd) {
      orig_bindHandles.call(this, isAdd);
      if (isAdd && window.PointerEvent) {
        for (var i = 0; i < this.handles.length; i++) {
          this.handles[i].style.touchAction = 'pan-y pinch-zoom';
        }
      }
    };
  }

  // Chạy trước khi Flickity init
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', patchFlickity);
  } else {
    patchFlickity();
  }
})();
// Cho phép 2 ngón trackpad scroll trong product gallery
document.addEventListener('DOMContentLoaded', function() {
  function enableTrackpadScroll() {
    var carousel = document.querySelector('.ProductGallery__Carousel');
    if (!carousel) return;

    var flkty = window.Flickity ? Flickity.data(carousel) : null;
    if (!flkty) {
      setTimeout(enableTrackpadScroll, 500);
      return;
    }

    var lastScroll = 0;
    var threshold = 15; // deltaX tối thiểu để trigger
    var cooldown = 400; // ms chờ giữa 2 lần scroll

    carousel.addEventListener('wheel', function(e) {
      if (Math.abs(e.deltaX) > Math.abs(e.deltaY)) {
        e.preventDefault();

        var now = Date.now();
        if (now - lastScroll < cooldown) return;

        if (Math.abs(e.deltaX) < threshold) return;

        lastScroll = now;

        if (e.deltaX > 0) {
          flkty.next();
        } else {
          flkty.previous();
        }
      }
    }, { passive: false });
  }

  enableTrackpadScroll();
});